export const canProceed = (validation) => {
  const stack = [];
  const checkValidation = (validation, status) => {
    Object.keys(validation).forEach((key) => {
      const currentItem = validation[key];
      if (typeof currentItem === 'object') {
        if (Object.keys(currentItem).length > 0) {
          checkValidation(currentItem, status);
        } else {
          stack.push(true);
        }
      } else {
        status = currentItem === '' || currentItem === null;
        stack.push(status);
        return status;
      }
    });
    return status;
  };
  checkValidation(validation);
  return stack.every((itemValue) => itemValue === true);
};
